export default () => {
    const items = document.querySelectorAll<HTMLUListElement>('.color-variable-item')
    const form = document.querySelector<HTMLElement>('.wcpa_form_outer')
    const resetButton = document.querySelector<HTMLButtonElement>('.reset_variations')
    const inputField = document.querySelector<HTMLInputElement>('.wcpa_field')

    if (!items || !form) {
        return
    }

    items.forEach((item:HTMLUListElement) => {
        item.addEventListener('click', () => {
            if ([
                'color-variable-item-couleur-melangee',
                'color-variable-item-other',
                'color-variable-item-mixed-colour',
                'color-variable-item-mischfarbe',
            ].some((className) => item.classList.contains(className))) {
                form.classList.add('is-active')
            } else {
                inputField.value = '';
                form.classList.remove('is-active')
            }
        })
    })

    resetButton.addEventListener('click', () => {
        form.classList.remove('is-active')
        resetButton.style.display = 'none'
        inputField.value = ''
    })
}
